import * as Sentry from '@sentry/react';

/**
 * True when Sentry has been initialized — it is only set up in PROD with a DSN
 * (see `src/main.tsx`). Every Sentry touchpoint guards on this so it is a no-op
 * in dev / local builds where there is no client.
 */
export const isSentryActive = (): boolean => Sentry.getClient() !== undefined;
